import React from "react";
import { Option, None } from "@swiggy-private/js-fp";

export interface ConfigContextValue {
    host: Option<string>;
    analyticsHost: Option<string>;
}

export const ConfigContext = React.createContext<ConfigContextValue>({ host: None, analyticsHost: None });

if (__DEV__) {
    ConfigContext.displayName = "ConfigContext";
}
